import styled from "styled-components";

const StyledDl = styled.dl`
  dt {
    font-size: 1rem;
  }

  dd {
    font-size: 0.875em;
  }
`;

export default StyledDl;
